import React, { Component, PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

class Model extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: []
    }
  }

  componentWillMount() {

  }

  render() {
    return (
      <FormGroup controlId="model">
        <Col componentClass={ControlLabel} sm={5}>
          Model *
        </Col>
        <Col sm={7}>
          <select
            className="custom-select"
            onChange={this.props.handleChangeModel}
            onBlur={this.props.calculation}
            value={this.props.model}
            id="model"
            required
          >
            <option value="">Please Select</option>
            {this.props.option.map((obj, index) => {
              const counter = index
              return (
                <option
                  value={obj.model}
                  key={counter}
                >{obj.model}</option>
              );
            })}
          </select>
        </Col>
      </FormGroup>
    )
  }
}

Model.propTypes = {
  handleChangeModel: PropTypes.func,
  option: PropTypes.array,
  calculation: PropTypes.func,
  model: PropTypes.string
};

export default Model;



// WEBPACK FOOTER //
// ./src/app/components/quotationCVComponent/model/Model.js